import {
  Action,
  ActionType,
  IMiniStressScoringResponse,
} from "models/stressCheck/miniStressScoringInformation";

import createReducer from "redux/createReducer";

export interface MiniStressScoringReducerType {
  loading: boolean;
  error?: any;
  miniStressScoringResponse?: IMiniStressScoringResponse;
}

const defaultState: MiniStressScoringReducerType = {
  loading: false,
  error: null,
  miniStressScoringResponse: undefined,
};

export const miniStressScoringReducer =
  createReducer<MiniStressScoringReducerType>(defaultState, {
    [ActionType.MINI_STRESS_SCORING](state: MiniStressScoringReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.MINI_STRESS_SCORING_ERROR](
      state: MiniStressScoringReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.MINI_STRESS_SCORING_SUCCESS](
      state: MiniStressScoringReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        miniStressScoringResponse: action.payload,
      };
    },

    [ActionType.MINI_STRESS_SCORING_RESET](
      state: MiniStressScoringReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        miniStressScoringResponse: undefined,
      };
    },
  });
